import AuthAction from './Auth';

const ACTION = {
  ...AuthAction.ACTION
};

const ACTION_TYPES = {
  ...AuthAction.ACTION_TYPES
};

const Auth = {
  ACTION,
  ACTION_TYPES
}

export default Auth;